import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = makeStyles(() => ({
    spinner: {
        margin: "50px 0",
    },
}));
